import Vue from 'vue'

import {
    Tab,
    Tabs,
    PullRefresh,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    Lazyload,
    Icon,
    Grid,
    GridItem,
    List,
    Button,
    NoticeBar,
    ImagePreview,
    Search,
    Row,
    Col,
    Toast,
    Dialog,
    Field,
    Uploader,
    Checkbox,
    CheckboxGroup,
    Progress,
    Popup,
    Loading,
    RadioGroup,
    Radio,
    Switch,
    Sticky,
    ActionSheet,
    Tag,
    NavBar,
    Image,
    IndexBar,
    IndexAnchor,
    Form,
	Tabbar,
	TabbarItem,
    Divider,
    TreeSelect,
    DropdownMenu,
    DropdownItem,
    SubmitBar,
    Card,
    Panel
} from 'vant';

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(Cell)
    .use(CellGroup)
    .use(Swipe)
    .use(SwipeItem)
    .use(Lazyload)
    .use(Icon)
    .use(Grid)
    .use(GridItem)
    .use(List)
    .use(Button)
    .use(NoticeBar)
    .use(ImagePreview)
    .use(Search)
    .use(Row)
    .use(Col)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Uploader)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Popup)
    .use(Loading)
    .use(Progress)
    .use(RadioGroup)
    .use(Radio)
    .use(Switch)
    .use(Sticky)
    .use(ActionSheet)
    .use(Tag)
    .use(NavBar)
    .use(Image)
    .use(IndexBar)
    .use(IndexAnchor)
    .use(Form)
    .use(Tabbar)
    .use(TabbarItem)
    .use(Divider)
    .use(TreeSelect)
    .use(DropdownMenu)
    .use(SubmitBar)
    .use(DropdownItem)
    .use(Card)
    .use(Panel);

import 'vant/lib/index.css'
